import React from 'react'
import TableData from '../Includes/Table/TableData'
import HeuresMobileTitre from './HeuresMobileTitre'
import HeuresToolbarMobile from './HeuresToolbarMobile'
import HeuresToolbarDesktop from './HeuresToolbarDesktop'
import FilterDemandesMobile from '../Includes/Filter/FilterDemandesMobile'
import FilterDemandesDesktop from '../Includes/Filter/FilterDemandesDesktop'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Paper
} from '@mui/material'
import {
  properties
} from '../../Settings/Heures'
import {
  SET_FILTERS_PAGE
} from '../../Redux/Actions/Filters'

const HeuresContent = ({
  data,
  total
}) => {
  const dispatch = useDispatch()
  const [page, setPage] = React.useState(0)
  const [filter, setFilter] = React.useState(false)
  const device = useSelector(state => state.device)
  const notification = useSelector(state => state.notifications.notification)
  return (
    <>
      {
        (device.mobile)
          ? <HeuresToolbarMobile
              setPage={setPage}
              setFilter={setFilter}
            />
          : null
      }
      <Paper>
        {
          (device.desktop)
            ? <HeuresToolbarDesktop/>
            : null
        }
        {
          (total > 0)
            ? <>
                {
                  (notification === '')
                    ? (device.mobile)
                      ? <FilterDemandesMobile
                          open={filter}
                          page="heures"
                          label="heures"
                          setting="heure"
                          setOpen={setFilter}
                          Commit={(state) => {
                            setPage(0)
                            dispatch(SET_FILTERS_PAGE('heures', state))
                          }}
                        />
                      : <FilterDemandesDesktop
                          page="heures"
                          setting="heure"
                          setPage={setPage}
                        />
                    : null
                }
                <TableData
                  data={data}
                  page={page}
                  setPage={setPage}
                  titre={HeuresMobileTitre}
                  pagination={(
                    (data.length > 0) &&
                    (notification === '')
                  )}
                  {...properties}
                />
              </>
            : null
        }
      </Paper>
    </>
  )
}

export default HeuresContent
